"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _Pin = _interopRequireDefault(require("./Pin"));
var _SidenavDivider = _interopRequireDefault(require("./SidenavDivider"));
var _SidenavTab = _interopRequireDefault(require("./SidenavTab"));
var _excluded = ["paper"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(pinEnabled, openWidth, open, withAppBarSpacing) {
  return (0, _core.makeStyles)(function (theme) {
    var appBarHeight = theme.mixins.toolbar.minHeight,
      backgroundColor = theme.palette.secondary.main;
    var borderRight = 'none';
    var closedWidth = 56;
    var overflowX = 'hidden';
    var boxShadow = theme.shadows[13];
    var marginTop = withAppBarSpacing ? appBarHeight : 0;
    var appBarSpacing = withAppBarSpacing ? "".concat(appBarHeight, "px") : '0';
    return {
      drawer: {
        flexShrink: 0,
        whiteSpace: 'nowrap'
      },
      drawerClose: {
        backgroundColor: backgroundColor,
        borderRight: borderRight,
        boxShadow: boxShadow,
        marginTop: marginTop,
        overflowX: overflowX,
        transition: 'width 150ms ease-out',
        width: closedWidth
      },
      drawerDocked: {
        marginRight: pinEnabled ? openWidth - closedWidth : 0,
        transition: 'margin 150ms ease-out',
        width: closedWidth
      },
      drawerOpen: {
        backgroundColor: backgroundColor,
        borderRight: borderRight,
        boxShadow: boxShadow,
        height: "calc(100vh - ".concat(appBarSpacing, ")"),
        marginTop: marginTop,
        overflowX: overflowX,
        transition: 'width 150ms ease-out',
        width: openWidth
      },
      hidden: {
        display: 'none'
      },
      list: {
        paddingBottom: theme.spacing(5),
        paddingTop: 0
      },
      pin: {
        backgroundColor: backgroundColor,
        bottom: 0,
        paddingLeft: open ? openWidth - 50 : 0,
        position: 'fixed',
        transition: 'padding 150ms ease-out'
      }
    };
  })();
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    pin: 'fuse_sidenav_pin',
    root: 'fuse_sidenav'
  },
  hidden: false,
  sidenavTabs: [],
  width: 240,
  withAppBarSpacing: false
};
var SideNavStyled = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx;
  var dataMetrics = props.dataMetrics,
    handleOnFocus = props.handleOnFocus,
    handleOnBlur = props.handleOnBlur,
    handleOnKeyDown = props.handleOnKeyDown,
    onPinChange = props.onPinChange,
    persistDrawerState = props.persistDrawerState,
    handleDrawerOpen = props.handleDrawerOpen,
    handleDrawerClose = props.handleDrawerClose,
    onClick = props.onClick,
    hidden = props.hidden,
    sidenavTabs = props.sidenavTabs,
    width = props.width,
    classes = props.classes,
    selectedTab = props.selectedTab,
    focusedTab = props.focusedTab,
    pin = props.pin,
    open = props.open,
    withAppBarSpacing = props.withAppBarSpacing;
  var paper = classes.paper,
    customClasses = (0, _objectWithoutProperties2["default"])(classes, _excluded);
  var styleClasses = useStyles(pin, width, open, withAppBarSpacing);
  var count = 0;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var generateCorrectListItem = function generateCorrectListItem(tab, index) {
    if (tab.divider) {
      return /*#__PURE__*/_react["default"].createElement(_SidenavDivider["default"], {
        key: "divider".concat(count++),
        automationId: tab.automationid,
        dataMetrics: tab.dataMetrics
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_SidenavTab["default"], {
      index: index,
      key: tab.text,
      onKeyDown: handleOnKeyDown(index, tab),
      onClick: onClick(index, tab),
      onFocus: handleOnFocus,
      persistDrawerState: persistDrawerState,
      selectedTab: selectedTab,
      focusedTab: focusedTab,
      sidenavIsOpen: open,
      sidenavWidth: width,
      tab: tab
    });
  };
  return /*#__PURE__*/_react["default"].createElement("nav", {
    "data-automation-id": "side-navigation",
    "data-metrics": mergedDataMetrics.root,
    className: hidden ? styleClasses.hidden : '',
    onBlur: handleOnBlur(true),
    onMouseEnter: function onMouseEnter() {
      return handleDrawerOpen();
    },
    onMouseLeave: function onMouseLeave() {
      return handleDrawerClose(null);
    },
    role: "navigation",
    "aria-label": pin ? 'pinned menu' : 'unpinned menu'
  }, /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    variant: "permanent",
    classes: _objectSpread({
      docked: styleClasses.drawerDocked,
      paper: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, styleClasses.drawerOpen, open), (0, _defineProperty2["default"])(_cx, styleClasses.drawerClose, !open), (0, _defineProperty2["default"])(_cx, classes.paper, classes.paper), _cx))
    }, customClasses),
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: styleClasses.list,
    onKeyDown: handleOnKeyDown(),
    onFocus: handleOnFocus,
    onBlur: handleOnBlur()
  }, sidenavTabs.map(function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      "aria-hidden": Boolean(tab.divider),
      "automation-id": tab.automaionId,
      "data-metrics": tab.dataMetrics || 'fuse_sidenav_tab',
      key: tab.text || count
    }, generateCorrectListItem(tab, index));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styleClasses.pin
  }, open && /*#__PURE__*/_react["default"].createElement(_Pin["default"], {
    dataMetrics: mergedDataMetrics.pin,
    pin: pin,
    pinType: "menu",
    setPin: function setPin(pinEnabled) {
      return onPinChange(pinEnabled);
    }
  }))));
});
SideNavStyled.defaultProps = defaultProps;
SideNavStyled.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes["default"].object,
  dataMetrics: _propTypes["default"].shape({
    pin: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  focusedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  handleDrawerClose: _propTypes["default"].func.isRequired,
  handleDrawerOpen: _propTypes["default"].func.isRequired,
  handleOnBlur: _propTypes["default"].func.isRequired,
  handleOnFocus: _propTypes["default"].func.isRequired,
  handleOnKeyDown: _propTypes["default"].func.isRequired,
  hidden: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onPinChange: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  persistDrawerState: _propTypes["default"].bool,
  pin: _propTypes["default"].bool,
  selectedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number.isRequired,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  sidenavTabs: _propTypes["default"].arrayOf(
  /**
   * sidenavTabs entry is either a tab definition or a divider
   */
  _propTypes["default"].oneOfType([_propTypes["default"].shape({
    automationid: _propTypes["default"].string,
    icon: _propTypes["default"].element.isRequired,
    route: _propTypes["default"].string,
    subSections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      childTabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        route: _propTypes["default"].string.isRequired,
        text: _propTypes["default"].string.isRequired
      })),
      header: _propTypes["default"].string
    })),
    text: _propTypes["default"].string.isRequired
  }), _propTypes["default"].shape({
    automationid: _propTypes["default"].string,
    divider: _propTypes["default"].bool
  })])),
  width: _propTypes["default"].number,
  withAppBarSpacing: _propTypes["default"].bool
} : {};
var _default = SideNavStyled;
exports["default"] = _default;